export default {"src":"/_next/static/image/public/images/referral_gift_banner.c89e9f52a0e114a59e5fb13674a5797e.svg","height":127,"width":116};